import { render, staticRenderFns } from "./CreateLeadPefai.vue?vue&type=template&id=c10c6854"
import script from "./CreateLeadPefai.vue?vue&type=script&lang=js"
export * from "./CreateLeadPefai.vue?vue&type=script&lang=js"
import style0 from "./CreateLeadPefai.vue?vue&type=style&index=0&id=c10c6854&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCardText,VCol,VForm,VIcon,VRow})
